import { render } from "./GeneralInput.vue?vue&type=template&id=5b1b62ab&scoped=true&ts=true"
import script from "./GeneralInput.vue?vue&type=script&lang=ts"
export * from "./GeneralInput.vue?vue&type=script&lang=ts"

import "./GeneralInput.vue?vue&type=style&index=0&id=5b1b62ab&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1b62ab"]])

export default __exports__